import { render, staticRenderFns } from "./DirectAccess.vue?vue&type=template&id=98fbe2b8&scoped=true"
import script from "./DirectAccess.vue?vue&type=script&lang=js"
export * from "./DirectAccess.vue?vue&type=script&lang=js"
import style0 from "./DirectAccess.vue?vue&type=style&index=0&id=98fbe2b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98fbe2b8",
  null
  
)

export default component.exports